import type { DomainDataProfile } from '../DomainDataProfile';
import { normalizeCsvKey } from './normalizeCsvKey';

export function detectFieldsFromProfile(
  headers: string[],
  profile: Pick<DomainDataProfile, 'fieldAliases'>
): Record<string, string | null> {
  const normalizedHeaders = headers.map((header) => ({
    header,
    key: normalizeCsvKey(header),
  }));

  const result: Record<string, string | null> = {};

  for (const [fieldId, aliases] of Object.entries(profile.fieldAliases)) {
    const normalizedAliases = aliases.map((alias) => normalizeCsvKey(alias));
    const match = normalizedHeaders.find((entry) =>
      normalizedAliases.includes(entry.key)
    );
    result[fieldId] = match?.header ?? null;
  }

  return result;
}
